export class NotificationItem {
  public readonly id = `${this.notificationNumber}-${this.itemNumber}`;

  public constructor(
    /**
     * Notification No   Number that identifies the notification.
     */
    public notificationNumber?: string,
    /**
     * Item Number in Item Record
     */
    public itemNumber?: string,
    /**
     * Number by which a piece of equipment can be clearly identified.
     */
    public equipmentNumber?: string,
    /**
     * Sort Number for Item   You can assign item numbers as desired. The system automatically proposes the highest previously assigned number + 1 as the sort number.   If you enter numbers manually, you can enter the same number for several items, since the system does not check whether these numbers already exist.
     */
    public sortNumber?: string,
    /**
     * Catalog Type - Object Parts   Key for the catalog type, which is used as a basis for object components
     */
    public catalogType?: string,
    /**
     * Code Group - Object Parts   Key for the code group, which groups the codes for the object parts.
     */
    public codeGroup?: string,
    /**
     * Part of Object   Key which narrows down the reference object more specifically.   The text preceding this field is \"object part\" in the standard system, however, it can or may have been changed in your company using the key word maintenance function.
     */
    public partOfObject?: string,
    /**
     * Date on Which Record Was Created
     */
    public createdDate?: Date,
    /**
     * Object Long Text Available   This indicator informs you that there is a long text for the object, that is, for the item, task and so on.
     */
    public longTextAvailable?: boolean,
    /**
     * Name of Person Who Created the Object
     */
    public createdBy?: string,
    /**
     * Notification Item Short Text   Short description of the notification item
     */
    public shortText?: string,
    /**
     * Short Text for Code (Up to 40 Characters in Length)   Text of up to 40 characters that describes the object in more detail. This description is also known as short text.
     */
    public causeShortText?: string,
    /**
     * Number of Text Lines in Line Table
     */
    public longTextLines?: string,
    /**
     * Name   This is the text name of a text. It can be a maximum of 70 characters in length. However, in specific text applications, only shorter names are usually allowed.   Do not use the characters \',\' or \'*\' in the text name or leave it blank.
     */
    public longTextName?: string,
    public longText?: string
  ) {}
}
